export default "__VITE_ASSET__a6dacd3f__"